// App.js
import React from "react";
import { Routes, Route } from "react-router-dom";

// User pages
import Home from "./pages/user/Home";
import Faq from "./pages/user/Faq";
import AboutUs from "./pages/user/AboutUs";
import Contact from "./pages/user/ContactUs";
import Design from "./pages/user/Design";
import Fashion from "./pages/user/ProductCategories";
import ProductCategoriesDetail from "./pages/user/ProductCategoriesDetail";

import Payment from "./pages/user/Payment";
import Orders from "./pages/user/OrderHistory";
import OrderTrack from "./pages/user/OrderTrack";
// import Cart from "./pages/user/Cart";
import Favorite from "./pages/user/Favorite";
import Cart from "./pages/user/Carts";


import MyDesign from "./pages/user/MyDesign";
import CheckoutPage from "./pages/user/CheckoutPage";


import Login from "./pages/auth/Login";

// Admin pages
import AdminDashboard from "./pages/admin/Dashboard";
// import AdminLogin from "./pages/admin/Login";
import OrderManagement from "./pages/admin/OrderManagement";
import OrderManagementDetail from './pages/admin/orderManagementDetail';
import ProductManagement from "./pages/admin/ProductManagement";
import ProductManagementDetail from "./pages/admin/ProductManagementDetail";
import UserAccountManagement from "./pages/admin/UserAccountManagement";
import DesignTemplate from "./pages/admin/DesignTemplate";
import DesignTemplateDetail from "./pages/admin/DesignTemplateDetail";
import PaymentTransactions from "./pages/admin/PaymentsTransactions";
import PaymentDetail from "./pages/admin/PaymentTransactionDetail";
import ShippingDelivery from "./pages/admin/ShippingDelivery";
import AnalyticsReports from "./pages/admin/AnalyticsReports";
import AdminAccountRoles from "./pages/admin/AdminAccountRoles";
import UserAccountManagementDetailPage from "./pages/admin/UserAccountManagementDetailPage";
import AdminAccountRolesDetail from "./pages/admin/AdminAccountDetailPage";
import ContactMessages from "./pages/admin/ContactUsMessagePage";
import ContactMessageDetail from "./pages/admin/ContactUsMessageDetailPage";

// Layout for user-facing pages
import UserLayout from "./layouts/UserLayout";
import AdminLayout from "./components/common/AdminLayout";
import { AdminLayoutProvider } from "./context/adminLayoutUseContext";
import PrivateRoute from "./components/common/PrivateRoute";
import ProtectedRoute from "./components/common/ProtectedRoute";
import UnauthorizedPage from "./components/common/UnauthorizedPage";
import PublicRoute from "./components/common/publicRoute";
import NotFoundPage from "./components/common/PageNotFound404Page";
import RoleBasedRoute from "./components/common/RoleBasedRoute";
import SignUp from "./pages/auth/SignupPage";
import Categories from "./pages/user/Categories";
import ResetPassword from "./pages/auth/passwordResetPage";
import { setNavigator } from './utils/navigation';
import { useNavigate } from 'react-router-dom';
import CouponManagement from "./pages/admin/CouponManagement";
import CouponBulkGenerate from "./pages/admin/CouponBulkGenerate";
import CouponAnalytics from "./pages/admin/CouponAnalytics";
import CouponDashboard from "./pages/admin/CouponDashboard";
function App() {
  const navigate = useNavigate();
  setNavigator(navigate);

  return (

    <Routes>
      <Route path="/unauthorized" element={<UnauthorizedPage isFullPage={true} />} />
      {/* Login route without UserLayout */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <PublicRoute>
            <SignUp />
          </PublicRoute>
        }
      />
      <Route
        path="/set-password/:token"
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        }
      />


      {/* User routes that should include the UserNavbar and Footer */}
      <Route element={<UserLayout />}>
        <Route path="/product-categories" element={<Categories />} />
        <Route index element={<Home />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/category/:id/:ProductCategoryName?" element={<Fashion />} />
        <Route path="/category/:id/:ProductCategoryName?/detail/:subCategoryId" element={<ProductCategoriesDetail />} />

      </Route>

      {/* Protected user routes (require login) */}
      <Route element={
        <PrivateRoute>
          <RoleBasedRoute is_admin={false}>
            <UserLayout />
          </RoleBasedRoute>
        </PrivateRoute>
      }>
        <Route path="/design/:productId/:isNew?/:projectId?" element={<Design />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/favorites" element={<Favorite />} />
        <Route path="/carts" element={<Cart />} />
        <Route path="/checkout/:productId/:isProject?/:projectId?" element={<CheckoutPage />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/track-order/:orderId?" element={<OrderTrack />} />
        <Route path="/my-designs" element={<MyDesign />} />
      </Route>


      {/* Admin routes without UserLayout */}
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <RoleBasedRoute is_admin={true}>
              <AdminLayoutProvider>
                <AdminLayout />
              </AdminLayoutProvider>
            </RoleBasedRoute>
          </PrivateRoute>
        }
      >
        <Route index element={<AdminDashboard />} />

        <Route path="coupon/management" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <CouponManagement />
          </ProtectedRoute>
        } /> 

        <Route path="coupon/bulk-generate" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <CouponBulkGenerate />
          </ProtectedRoute>
        } />

         <Route path="coupon/analytics" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <CouponAnalytics />
          </ProtectedRoute>
        } />
         <Route path="coupon" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <CouponDashboard />
          </ProtectedRoute>
        } />


        <Route path="orders" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <OrderManagement />
          </ProtectedRoute>
        } />

        <Route path="orders/:orderUid" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <OrderManagementDetail />
          </ProtectedRoute>
        } />
        <Route path="products" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <ProductManagement />
          </ProtectedRoute>
        } />
        <Route path="products/:id" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <ProductManagementDetail />
          </ProtectedRoute>
        } />
        <Route path="users" element={
          <ProtectedRoute allowedPermissions={["manage_users"]}>
            <UserAccountManagement />
          </ProtectedRoute>
        } />
        <Route path="users/:id" element={
          <ProtectedRoute allowedPermissions={["manage_users"]}>
            <UserAccountManagementDetailPage />
          </ProtectedRoute>
        } />
        <Route path="templates" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <DesignTemplate />
          </ProtectedRoute>
        } />
        <Route path="templates/:id" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <DesignTemplateDetail />
          </ProtectedRoute>
        } />
        <Route path="payments" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <PaymentTransactions />
          </ProtectedRoute>} />
        <Route path="payments/:transactionId" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <PaymentDetail />
          </ProtectedRoute>
        } />
        <Route path="shipping" element={
          <ProtectedRoute allowedPermissions={["edit_content"]}>
            <ShippingDelivery />
          </ProtectedRoute>} />
        <Route path="analytics" element={
          <ProtectedRoute allowedPermissions={["view_reports"]}>
            <AnalyticsReports />
          </ProtectedRoute>
        } />
        <Route path="roles" element={
          <ProtectedRoute allowedPermissions={["manage_users"]}>
            <AdminAccountRoles />
          </ProtectedRoute>} />
        <Route path="roles/:id" element={
          <ProtectedRoute allowedPermissions={["manage_users"]}>
            <AdminAccountRolesDetail />
          </ProtectedRoute>} />


        <Route path="contact-us-messages" element={
          <ProtectedRoute allowedPermissions={["view_reports"]}>
            <ContactMessages />
          </ProtectedRoute>} />
        <Route path="contact-us-messages/:id" element={
          <ProtectedRoute allowedPermissions={["view_reports"]}>
            <ContactMessageDetail />
          </ProtectedRoute>} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>

  );
}

export default App;
